module.exports = __webpack_public_path__ + "img/header-engagementRingsHeart@2x.5b43ac6.webp";